import React from 'react';
import { XCircleIcon } from '@heroicons/react/solid';
import { Drawer as DrawerAntd } from 'antd';
const Drawer = ({ className, title, placement, open, onClose, rootClassName, height, footer, children, ...rest }) => {
    return (React.createElement(DrawerAntd, { className: className, placement: placement, 
        // height="90%"
        onClose: onClose, open: open, title: title, rootClassName: rootClassName, closeIcon: React.createElement(XCircleIcon, { height: 20, width: 20, className: "text-grayScale05 cursor-pointer" }), footer: footer, ...rest }, children));
};
export default Drawer;
